import React from 'react'
import { SVGIconProps } from '../types'
const SvgNotes = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path fill="none" d="M0 0h24v24H0z" />
    <path d="M3 18h12v-2H3zM3 6v2h18V6zm0 7h18v-2H3z" />
  </svg>
)
export default SvgNotes
